export var URL_DATA = {
  ORGANIZATION: 'orgDetails',
  TREE_DATA: 'treeData',
  STORYBOARD_TREEDATA: 'storyboardTreeData',
  PROJECT_DETAILS: 'projectDetails',
  DASHBOARD_FILTER: 'dashboardFilter',
  STORYBOARD_FILTER: 'storyBoardFilter',
  SHOW_STORYBOARD: 'showStoryboard'
};